import React, { FC } from "react";

import { IconButtonProps } from "@mui/material/IconButton";
import Stack, { StackProps } from "@mui/material/Stack";
import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

import IconButton from "@rui/IconButton";

export const Card = styled((props: StackProps) => (
  <Stack direction="row" spacing="8px" {...props} />
))(({ onClick, theme }) => ({
  backgroundColor: "#fff",
  padding: "8px",
  flexGrow: 1,
  borderRadius: "4px",
  border: "1px solid #FFF",
  transition: "all 100ms ease",
  "& .highlight__copy-link": { opacity: 0 },
  "&:hover": {
    cursor: onClick ? "pointer" : "default",
    borderColor: onClick ? theme.palette.shades.primary[500] : undefined,
    "& .highlight__copy-link": { opacity: 1 },
  },
}));

export const Timestamp = styled((props: TypographyProps) => (
  <Typography variant="caption" {...props} />
))(({ theme }) => ({
  fontSize: "0.75rem",
  fontFamily: theme.typography.fontFamilySecondary,
  color: theme.palette.shades.neutral[500],
  lineHeight: "15px",
}));

export const Label = styled((props: TypographyProps) => (
  <Typography variant="body1" {...props} />
))(({ theme }) => ({
  fontSize: "0.875rem",
  fontFamily: theme.typography.fontFamilySecondary,
  fontWeight: 500,
  color: theme.palette.shades.neutral[700],
  lineHeight: "18px",
}));

export const Quote = styled((props: TypographyProps) => (
  <Typography variant="body1" {...props} />
))(({ theme }) => ({
  fontSize: "0.875rem",
  fontFamily: theme.typography.fontFamilySecondary,
  fontWeight: 400,
  color: theme.palette.shades.neutral[500],
  lineHeight: "18px",
  borderLeft: `2px solid ${theme.palette.shades.neutral[100]}`,
  paddingLeft: "6px",
}));

export const LinkButton = styled<FC<IconButtonProps>>((props) => (
  <IconButton size="small" {...props} />
))({
  "& .MuiSvgIcon-root": { fontSize: "16px" },
});
